import { CssBaseline, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { themeSettings } from "theme";
import Layout from "scenes/layout";
import Dashboard from "scenes/dashboard";
import Configuration from "scenes/Configuration/Configuration";
import Ota from "scenes/Ota_Upgrade/Ota";
import DataLogs from "scenes/Logs/DataLogs";
import SystemLogs from "scenes/Logs/SystemLogs";
import Management from "scenes/Management/Management";
import Backup from "scenes/Backup/Backup";
import StateDetail from "scenes/dashboard/StateDetail";
import DisplaySite from "scenes/DisplaySite/DisplaySite";
import DataBySite from "scenes/DataBySite/DataBySite";
import AccessControl from "scenes/AccessControl/AccessControl";
import AdditionalControl from "scenes/AdditionalControl/AdditionalControl";
import HistoricalData from "scenes/HistoricalData/HistoricalData";
import LoginPage from "scenes/Authentication/Login/LoginPage";
import PrivateRoute from "components/PrivateRoute";
import ProtectedRoute from "components/ProtectedRoute";
import OutDoorCabinet from "scenes/OutDoorCabinet/OutDoorCabinet";
import ViewMore from "scenes/DataBySite/ViewMore/ViewMore";
import HybridUps from "scenes/HybridUPS/HybridUps";
import DataCalculator from "scenes/DataCalculator/DataCalculator";
import NewConfig from "scenes/NewConfig/NewConfig";

function App() {
  // Use a hardcoded 'light' mode for the theme
  const theme = createTheme(themeSettings("light"));

  return (
    <div className="app">
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Routes>
            <Route path="/calculator" element={<DataCalculator />} />
            <Route path="/" element={<LoginPage />} />
            <Route element={<Layout />}>
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/:stateName/displaySite"
                element={
                  <PrivateRoute>
                    <DisplaySite />
                  </PrivateRoute>
                }
              />
              <Route
                path="/get_data_by_site"
                element={
                  <PrivateRoute>
                    <DataBySite />
                  </PrivateRoute>
                }
              />
              <Route
                path="/state/:stateName"
                element={
                  <PrivateRoute>
                    {" "}
                    <StateDetail />
                  </PrivateRoute>
                }
              />
              <Route
                path="/access_control"
                element={
                  <PrivateRoute>
                    {" "}
                    <AccessControl />
                  </PrivateRoute>
                }
              />
              <Route
                path="/hybrid_ups"
                element={
                  <PrivateRoute>
                    {" "}
                    <HybridUps />
                  </PrivateRoute>
                }
              />
              <Route
                path="/configuration"
                element={
                  <PrivateRoute>
                    {" "}
                    <Configuration />
                  </PrivateRoute>
                }
              />
              <Route
                path="/historical_data"
                element={
                  <PrivateRoute>
                    <HistoricalData />
                  </PrivateRoute>
                }
              />
              <Route
                path="/outdoor_cabinet"
                element={
                  <PrivateRoute>
                    <OutDoorCabinet />
                  </PrivateRoute>
                }
              />
              <Route
                path="/view_more"
                element={
                  <PrivateRoute>
                    <ViewMore />
                  </PrivateRoute>
                }
              />
              <Route
                path="/ota_upgrade"
                element={
                  <PrivateRoute>
                    <Ota />
                  </PrivateRoute>
                }
              />
              <Route
                path="/logs/data_logs"
                element={
                  <PrivateRoute>
                    <DataLogs />
                  </PrivateRoute>
                }
              />
              <Route
                path="/logs/system_logs"
                element={
                  <PrivateRoute>
                    <ProtectedRoute>
                      <SystemLogs />
                    </ProtectedRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/user_management"
                element={
                  <PrivateRoute>
                    {" "}
                    <ProtectedRoute>
                      <Management />
                    </ProtectedRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/additional_control"
                element={
                  <PrivateRoute>
                    <AdditionalControl />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backup"
                element={
                  <PrivateRoute>
                    <Backup />
                  </PrivateRoute>
                }
              />
            </Route>
          </Routes>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
